import { useQuery } from 'react-query';

import { DocBundleItemDto } from '../../../../backend/src/matter/doc/dto/get-doc-bundle-items.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useGetDocBundleItems = ({
  matterId,
  subsetId,
  docIds,
  enabled = true,
}: {
  matterId: string;
  subsetId: string;
  docIds: string[];
  enabled?: boolean;
}) => {
  const { getFetchConfig } = useGetFetchConfig();

  return useQuery<DocBundleItemDto[]>(
    [QueryEntity.DocBundleItems, { matterId, subsetId, docIds }],
    async () => {
      const fetchConfig = getFetchConfig({ method: FetchMethod.POST, data: { docIds } });
      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/docs/bundle-items`,
        fetchConfig,
      );
      if (!res.ok) {
        throw new Error(`Failed to load bundle items (${res.status})`);
      }
      return res.json();
    },
    { enabled: enabled && docIds.length > 0 && !!matterId && !!subsetId },
  );
};
